/**
 * Shared sticky Add-to-Cart bar (sections/sticky-add-to-cart.liquid), rendered once globally.
 * Never talks to the cart API itself for most templates — its button just clicks whichever real
 * '[data-type="add-to-cart-form"] .product-form__submit' button is on the page, so it stays correct
 * no matter which of the (up to 7) product templates' buy-box markup is currently rendered.
 *
 * GABA Calm Pouches is the exception: its buy box (product-pouches-buybox.js) has no such form —
 * '[data-gcp-cta]' posts to /cart/add.js itself, adding whatever plan is currently selected there.
 * Clicking that button from the sticky bar would silently add the buy box's current selection
 * instead of the one-time default price this bar displays, so for that case the bar does its own
 * minimal /cart/add.js call for the plain default variant (data-variant-id below) instead of
 * forwarding the click. '[data-gcp-cta]' is still used as the real-button visibility target.
 */
(function () {
  var bar = document.getElementById('StickyAtc');
  if (!bar) return;

  var standardFormSelector = 'product-info [data-type="add-to-cart-form"] .product-form__submit';

  var realSubmitButton = document.querySelector(standardFormSelector) || document.querySelector('[data-gcp-cta]');
  var stickyButton = document.getElementById('StickyAtcButton');
  var stickyButtonText = document.getElementById('StickyAtcButtonText');
  var priceCurrentEl = document.getElementById('StickyAtcPriceCurrent');
  var priceEl = document.getElementById('StickyAtcPrice');
  var imageEl = document.getElementById('StickyAtcImage');

  var variantsJson = document.getElementById('StickyAtcVariants');
  var variants = [];
  if (variantsJson) {
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      variants = [];
    }
  }

  if (realSubmitButton && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          // Not just "off-screen": only show once the real button has scrolled
          // past above the viewport, not before the page has scrolled down to it.
          bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
        });
      },
      { threshold: 0 }
    );
    observer.observe(realSubmitButton);
  }

  function openCartDrawer() {
    ['cart:refresh', 'cart:build', 'cart-updated', 'cart:updated'].forEach(function (ev) {
      document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
    });
    var trigger = document.querySelector(
      '[data-gcp-cart-trigger], #cart-icon-bubble, .js-drawer-open-cart, [data-cart-drawer-toggle], ' +
        '[data-drawer-open="cart"], #CartDrawer-Toggle, a[href="/cart"][aria-haspopup], .header__icon--cart'
    );
    if (trigger) trigger.click();
  }

  function addDefaultVariantToCart() {
    var variantId = stickyButton.dataset.variantId;
    if (!variantId) return;

    stickyButton.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    })
      .then(function (r) {
        return r
          .json()
          .catch(function () { return {}; })
          .then(function (body) { return { ok: r.ok, status: r.status, body: body }; });
      })
      .then(function (res) {
        stickyButton.disabled = false;
        if (!res.ok) {
          console.error('[sticky-atc] add to cart failed', res.status, res.body);
          return;
        }
        openCartDrawer();
      })
      .catch(function (e) {
        stickyButton.disabled = false;
        console.error('[sticky-atc] could not reach /cart/add.js', e);
      });
  }

  if (stickyButton) {
    stickyButton.addEventListener('click', function () {
      if (stickyButton.disabled) return;
      var standardTarget = document.querySelector(standardFormSelector);
      if (standardTarget) {
        standardTarget.click();
        return;
      }
      if (document.querySelector('[data-gcp-cta]')) {
        addDefaultVariantToCart();
      }
    });
  }

  function moneyFormat(cents) {
    var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
    var amount = (cents / 100).toLocaleString(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: currency,
    });
    return amount + ' ' + currency;
  }

  function updateForVariant(variant) {
    if (!variant) return;

    if (priceCurrentEl) priceCurrentEl.textContent = moneyFormat(variant.price);
    if (priceEl) {
      var compareEl = priceEl.querySelector('.sticky-atc__price-compare');
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (!compareEl) {
          compareEl = document.createElement('s');
          compareEl.className = 'sticky-atc__price-compare';
          priceEl.insertBefore(compareEl, priceEl.firstChild);
        }
        compareEl.textContent = moneyFormat(variant.compare_at_price);
      } else if (compareEl) {
        compareEl.remove();
      }
    }

    if (imageEl && variant.featured_image && variant.featured_image.src) {
      var separator = variant.featured_image.src.indexOf('?') === -1 ? '?' : '&';
      imageEl.src = variant.featured_image.src + separator + 'width=160';
      imageEl.srcset = '';
    }

    if (stickyButton) stickyButton.disabled = !variant.available;
    if (stickyButtonText) {
      stickyButtonText.textContent =
        variant.available || !window.variantStrings
          ? stickyButton.dataset.ctaText
          : window.variantStrings.soldOut;
    }
  }

  function findVariant(id) {
    id = String(id);
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === id) return variants[i];
    }
    return null;
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      if (event && event.data && event.data.variant) updateForVariant(event.data.variant);
    });
  }

  function updatePriceText(price, comparePrice) {
    if (!price) return;
    if (priceCurrentEl) priceCurrentEl.textContent = price;
    if (priceEl) {
      var compareEl = priceEl.querySelector('.sticky-atc__price-compare');
      if (comparePrice) {
        if (!compareEl) {
          compareEl = document.createElement('s');
          compareEl.className = 'sticky-atc__price-compare';
          priceEl.insertBefore(compareEl, priceEl.firstChild);
        }
        compareEl.textContent = comparePrice;
      } else if (compareEl) {
        compareEl.remove();
      }
    }
  }

  document.addEventListener('bundle-option:change', function (event) {
    if (!event.detail) return;
    if (event.detail.variantId) updateForVariant(findVariant(event.detail.variantId));
    updatePriceText(event.detail.price, event.detail.comparePrice);
  });

  var checkedBundleRadio = document.querySelector('.vr-opt__radio:checked');
  if (checkedBundleRadio && checkedBundleRadio.value) {
    updateForVariant(findVariant(checkedBundleRadio.value));
    updatePriceText(checkedBundleRadio.dataset.price, checkedBundleRadio.dataset.comparePrice);
  }
})();
